import React, { useState, useEffect, useContext } from "react";
import BannerBlock from "../../components/BannerBlock";
import { ContainerBanner } from "./BannerContainer.styled";
import { ALL_QUESTION_CATEGORIES } from "../../GraphQL/Queries";
import { useMutation, useLazyQuery } from "@apollo/client";
import {
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
  CREATE_ANSWER_QUESTION_SURVEY,
} from "../../GraphQL/Mutations";
import { uploadFile, getFile } from "../../services/FileManager";
import { getStateLogin } from "../LayoutHome/stateLogin";
import { ContextQuestions } from "../../Store/StoreQuestions";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import { theme as themeConfig } from "../../themes/themes";

const BannerContainer = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [folderName] = useState("Surveys");
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [showLoader, setshowLoader] = useState(false);
  const [title, setTitle] = useState("");
  const [answerQuestion, setAnswerQuestion] = useState("");
  const [colorPicker, setColorPicker] = useState(themeConfig.primary.purple);
  const [mandatory, setMandatory] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [elementKey, setelementKey] = useState(2);
  const [refTitle, setRefTitle] = useState("");
  const [refIsMandatory, setRefIsMandatory] = useState(false);
  const [refValidationText, setRefValidationText] = useState("");
  const [refColor, setRefColor] = useState("");
  const [refCategory, setRefCategory] = useState("");
  const [refCantImage, setCantImage] = useState(0);
  const [categories, setcategories] = useState([]);
  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [nameSelectedFile, setNameSelectedFile] = useState("");
  const [urlPreviewImage, setUrlPreviewImage] = useState(null);
  const [getQuestionCategories, { error, loading }] = useLazyQuery(
    ALL_QUESTION_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          const allCategories = data.allCategoriesQuestion.outputData.map(
            (c) => ({ ...c })
          );
          console.log(dataSurvey)
          if (dataSurvey?.isGlobal) {
            setcategories(
              allCategories.filter((f) => f.description === "Global")
            );
          } else {
            setcategories(
              allCategories.filter((f) => f.description !== "Global")
            );
          }
        }
      },
    }
  );
  const [questionSettings, SetQuestionSettings] = useState([
    { id: 1, name: "InfoBanner", nameImage: "" },
  ]);
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "InfoBanner",
    questionSettings: questionSettings,
  });

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      let jsonConfSurveyQuestion = JSON.parse(globalProps.GjsonConfiguration);

      setTitle(globalProps.GnameQuestion);
      setRefTitle(globalProps.GnameQuestion);
      setRefCategory(globalProps.GidCategoryQuestion);

      if (globalProps.GvalidationText !== "") {
        setMandatory(
          globalProps.GisMandatory && globalProps.GisMandatory !== null
            ? globalProps.GisMandatory
            : false
        );
        setRefIsMandatory(globalProps.GisMandatory);
        setRefValidationText(globalProps.GvalidationText);
      }

      SetQuestionSettings(jsonConfSurveyQuestion.questionSettings);

      setNameSelectedFile(jsonConfSurveyQuestion.questionSettings[0].nameImage);

      if (
        jsonConfSurveyQuestion.questionSettings &&
        jsonConfSurveyQuestion.questionSettings[0].nameImage
      ) {
        getFile(jsonConfSurveyQuestion.questionSettings[0].nameImage).then(
          (response) => {
            if (response && response.type !== "archivo-noexistente/json") {
              setUrlPreviewImage(URL.createObjectURL(response));
            }
          }
        );
      }

      setconfigQuestionStyle(jsonConfSurveyQuestion);
      // setKeyAndId(keyAndId)
      setAnswerQuestion();
      setColorPicker();
      setelementKey();
      setRefColor();
      setCantImage();
    }
    getQuestionCategories();
  }, []);

  useEffect(() => {
    SetQuestionSettings([
      { id: 1, name: "InfoBanner", nameImage: nameSelectedFile },
    ]);
  }, [nameSelectedFile]);

  let loadCategories = () => {
    if (loading) return <option key="0">Loading...</option>;
    if (error) return <option key="0">Error :(</option>;
    if (!loading && !error && categories)
      return (
        categories &&
        categories.map(({ recordState, description, idCategoryQuestion }) => {
          if (recordState.toUpperCase() === "ACTIVE") {
            return (
              <option key={idCategoryQuestion} value={idCategoryQuestion}>
                {description}
              </option>
            );
          }
          return null;
        })
      );
  };
  let updateInQuestionSurvey = (idInBank, isMandatory, questionSettings) => {
    configQuestionStyle.questionSettings = questionSettings;

    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: refCategory,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: refValidationText,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
    });
  };
  let saveQuestionSurvey = (idQuestion, isMandatory, questionSettings) => {
    configQuestionStyle.questionSettings = questionSettings;
    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "SAVE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: refCategory,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: refValidationText,
          GidQuestion: idQuestion,
          GidQuestionSurvey: response.data.createQuestionSurvey,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: 9,
          createUser: getStateLogin(),
        },
      })
        .then((data) => {
          if (data.createAnswerQuestionSurvey) {
            NotificationManager.success(
              "New questions were saved successfully",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    });
  };

  let saveQuestionBank = () => {
    let title = refTitle;
    let category = refCategory;
    let isMandatory = refIsMandatory;
    let validationText = refValidationText;
    if (title !== "" && category !== "") {
      if ((isMandatory && validationText !== "") || !isMandatory) {
        if (selectedFiles.length > 0) {
          uploadFile(selectedFiles, folderName)
            .then((imageName) => {
              let arrayNames = JSON.parse(imageName);
              let newQueSettings = questionSettings;
              newQueSettings[0].nameImage = arrayNames[0].newName;
              SetQuestionSettings(newQueSettings);
              proceedToSave();
            })
            .catch((error) => {
              const errorMessage = error.message.split("\n")[0];
              NotificationManager.error(errorMessage, "", 5000);
            });
        } else {
          proceedToSave();
        }
      }
    }
  };

  let proceedToSave = () => {
    let title = refTitle;
    let category = refCategory;
    let isMandatory = refIsMandatory;
    let validationText = refValidationText;
    if (title !== "" && category !== "") {
      if (isMandatory && validationText !== "") {
        if (globalProps.GidQuestionSurvey) {
          updateQuestionBank({
            variables: {
              idQuestion: globalProps.GidQuestion,
              nameQuestion: title,
              validationText: validationText,
              idCategoryQuestion: parseInt(category),
              active: true,
              lastUpdateUser: getStateLogin(),
            },
          }).then(() => {
            updateInQuestionSurvey(
              globalProps.GidQuestion,
              isMandatory,
              questionSettings
            );
          });
        } else {
          createQuestionBank({
            variables: {
              nameQuestion: title,
              validationText: validationText,
              idCategoryQuestion: parseInt(category),
              active: true,
              createUser: getStateLogin(),
            },
          }).then((saveResponse) => {
            saveQuestionSurvey(
              saveResponse.data.createQuestionBank,
              isMandatory,
              questionSettings
            );
          });
        }
      }
      if (!isMandatory) {
        if (globalProps.GidQuestionSurvey) {
          updateQuestionBank({
            variables: {
              idQuestion: globalProps.GidQuestion,
              nameQuestion: title,
              validationText: validationText,
              idCategoryQuestion: parseInt(category),
              active: true,
              lastUpdateUser: getStateLogin(),
            },
          }).then(() => {
            updateInQuestionSurvey(
              globalProps.GidQuestion,
              isMandatory,
              questionSettings
            );
          });
        } else {
          createQuestionBank({
            variables: {
              nameQuestion: title,
              validationText: validationText,
              idCategoryQuestion: parseInt(category),
              active: true,
              createUser: getStateLogin(),
            },
          }).then((saveResponse) => {
            saveQuestionSurvey(
              saveResponse.data.createQuestionBank,
              isMandatory,
              questionSettings
            );
          });
        }
      }
    }
  };

  let handleEdit = () => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
  };
  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];

    let jsonConfSurveyQuestion = JSON.parse(objG.GjsonConfiguration);

    setTitle(objG.GnameQuestion);
    setRefTitle(objG.GnameQuestion);
    setRefCategory(objG.GidCategoryQuestion);

    if (objG.GvalidationText !== "") {
      setMandatory(
        globalProps.GisMandatory && globalProps.GisMandatory !== null
          ? globalProps.GisMandatory
          : false
      );
      setRefIsMandatory(objG.GisMandatory);
      setRefValidationText(objG.GvalidationText);
    }

    SetQuestionSettings(jsonConfSurveyQuestion.questionSettings);

    setNameSelectedFile(jsonConfSurveyQuestion.questionSettings[0].nameImage);

    if (
      jsonConfSurveyQuestion.questionSettings &&
      jsonConfSurveyQuestion.questionSettings[0].nameImage
    ) {
      getFile(jsonConfSurveyQuestion.questionSettings[0].nameImage).then(
        (response) => {
          if (response && response.type !== "archivo-noexistente/json") {
            setUrlPreviewImage(URL.createObjectURL(response));
          }
        }
      );
    }

    setconfigQuestionStyle(jsonConfSurveyQuestion);

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });
  };

  let handleDelete = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          setshowLoader(false);
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.map((q, index) => {
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      setshowLoader(false);
      let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
      copy.questions.splice(globalProps.GindexQuestion, 1);
      copy.questions.map((q, index) => {
        q.GindexQuestion = index;
        q.Gorder = index + 1;
      });
      dispatch({ type: "CLEAN_QUESTIONS" });
      dispatch({ type: "DELETE_QUESTIONS", payload: copy });
    }
  };

  return (
    <ContainerBanner>
      <BannerBlock
        title={title}
        setTitle={setTitle}
        answerQuestion={answerQuestion}
        setAnswerQuestion={setAnswerQuestion}
        questionSettings={questionSettings}
        SetQuestionSettings={SetQuestionSettings}
        colorPicker={colorPicker}
        setColorPicker={setColorPicker}
        mandatory={mandatory}
        setMandatory={setMandatory}
        isUpdate={isUpdate}
        setIsUpdate={setIsUpdate}
        editable={globalProps.GisEdit}
        elementKey={elementKey}
        setelementKey={setelementKey}
        loadCategories={loadCategories}
        refTitle={refTitle}
        setRefTitle={setRefTitle}
        refIsMandatory={refIsMandatory}
        setRefIsMandatory={setRefIsMandatory}
        refValidationText={refValidationText}
        setRefValidationText={setRefValidationText}
        refColor={refColor}
        setRefColor={setRefColor}
        refCategory={refCategory}
        setRefCategory={setRefCategory}
        saveQuestionBank={saveQuestionBank}
        handleEdit={handleEdit}
        handleCancel={handleCancel}
        refCantImage={refCantImage}
        setCantImage={setCantImage}
        error={error}
        loading={loading}
        configQuestionStyle={configQuestionStyle}
        setconfigQuestionStyle={setconfigQuestionStyle}
        setSelectedFiles={setSelectedFiles}
        setNameSelectedFile={setNameSelectedFile}
        urlPreviewImage={urlPreviewImage}
        handleDeleteQuestion={handleDelete}
        idQuestionSurvey={globalProps.GidQuestionSurvey}
      />
      {showLoader && <ModalLoader></ModalLoader>}
    </ContainerBanner>
  );
};

export default BannerContainer;
